import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { DecimalPipe } from '@angular/common'

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatCardModule, MatSelectModule, MatProgressSpinnerModule, MatToolbarModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatGridListModule, MatDialogModule } from '@angular/material';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { TransferComponent } from './transfer/transfer.component';

import { HelperService } from './service/helper/helper.service';
import { AuthService } from './service/auth/auth.service';
import { ApiService } from './service/api/api.service'
import { TxhistoryComponent } from './txhistory/txhistory.component';
import { NitPipe } from './nit.pipe';
import { CreatewalletComponent } from './createwallet/createwallet.component';
import { ExportComponent } from './export/export.component';
import { ImportComponent } from './import/import.component';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { ModalComponent } from './modal/modal.component';
import { ReceiveComponent } from './receive/receive.component';

import { ClipboardModule } from 'ngx-clipboard';
import { AngularFontAwesomeModule } from 'angular-font-awesome';


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginComponent,
    TransferComponent,
    TxhistoryComponent,
    NitPipe,
    CreatewalletComponent,
    ExportComponent,
    ImportComponent,
    ModalComponent,
    ReceiveComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatSelectModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    FormsModule,
    NgxQRCodeModule,
    MatDialogModule,
    ClipboardModule,
    AngularFontAwesomeModule,
    HttpModule
  ],
  providers: [
    HelperService,
    AuthService,
    ApiService,
    DecimalPipe
  ],
  bootstrap: [AppComponent],
  entryComponents: [ModalComponent]
})
export class AppModule { }
